module.exports = __webpack_public_path__ + "img/10876_L.5c1f8275.png";